<template>
  <div class="badge-block">
    <small style="position: relative;text-align:center;">{{dataConsulta}}</small>
    <br>
    <span class="my-badge" :class="getBadgeClass(ultimoResultado, label)">{{label}}</span>
  </div>
</template>

<script>
  export default {
    props: ['ultimoResultado', 'label'],
    methods: {
      getBadgeClass(resultado, tipo) {
        if (!resultado)
          return 'grey';

        if (tipo === 'kredits' && !resultado.status) {
          return 'green';
        }

        if (!resultado.status)
          return 'grey';

        if (tipo === 'receita_federal') {
          let log = JSON.parse(resultado.log);
          if (log.situacao == 'Situação: Desconhecida') {
            return 'grey';
          }
        }

        if (tipo === 'tjam') {
          let log = JSON.parse(resultado.log);
          if (log.doc.length == 0 && log.nome.length > 0) {
            return 'orange';
          }
        }

        /*if(tipo === 'score'){
          //key valor so existe quando é score
          let valor = resultado.valor;
          if(valor){
            if (valor == 0 && valor <= 35.5) {
                        return 'red';
              }else if (valor > 35.5 && valor <= 44.4){
                return 'orange';
              }else if(valor > 44.4){
                 return 'green';
              }
          }else{
            return 'grey';
          }         
        }*/

        if (resultado.status == 'OK')
          return 'green';
        if (resultado.status != 'OK')
          return 'red';

        return 'grey';
      }
    },
    computed: {
      dataConsulta() {
        if (!this.ultimoResultado) {
          return 'Sem Consulta';
        }

        //verificar a data do score
        /*if(this.label == 'score'){
          if(this.ultimoResultado.score_criado_em){
            return moment(this.ultimoResultado.score_criado_em).format('DD/MM/YYYY');
          }
            return 'Sem Consulta';
        }else{*/
          return moment(this.ultimoResultado.created_at).format('DD/MM/YYYY');
        //}       
        
      }
    }
  }
</script>
<style scoped>
  .badge-block {
    border: 0px solid;
    display: inline-block;
    min-width: 75px;
    margin-right: 15px !important;
    text-align: center;
  }

  .my-badge {
    float: left !important;
    margin-left: 0px !important;
    min-width: inherit;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/common/BadgeConsulta.vue